/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteTapsPrescription } from '../fn/prescriptions-internal-api-to-be-used-from-receiver/delete-taps-prescription';
import { DeleteTapsPrescription$Params } from '../fn/prescriptions-internal-api-to-be-used-from-receiver/delete-taps-prescription';

@Injectable({ providedIn: 'root' })
export class PrescriptionsInternalApiToBeUsedFromReceiverService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deleteTapsPrescription()` */
  static readonly DeleteTapsPrescriptionPath = '/api/internal/prescriptions/{prescriptionNumber}';

  /**
   * Deactivate the prescription with the treatment id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTapsPrescription()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTapsPrescription$Response(params: DeleteTapsPrescription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTapsPrescription(this.http, this.rootUrl, params, context);
  }

  /**
   * Deactivate the prescription with the treatment id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTapsPrescription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTapsPrescription(params: DeleteTapsPrescription$Params, context?: HttpContext): Observable<void> {
    return this.deleteTapsPrescription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
